import { createQueryKeys } from '@lukemorales/query-key-factory'

import type { GetListingsByFilterParams } from '../schema/listing'

type SearchListingsQueryParams = Omit<GetListingsByFilterParams, 'skip'>
type SavedListingsQueryParams = {
  businessId: number
  limit?: number
}
type ListingPricingQueryParams = {
  listingId: number
  buyerBusinessId: number
}

export const listings = createQueryKeys('listings', {
  byId: (listingId: number) => ({
    queryKey: [listingId],
  }),
  pricing: ({ listingId, buyerBusinessId }: ListingPricingQueryParams) => ({
    queryKey: [{ listingId, buyerBusinessId }],
  }),
  browse: (params: SearchListingsQueryParams) => ({
    queryKey: [{ params }],
  }),
  savedListings: (params: SavedListingsQueryParams) => ({
    queryKey: [{ params }],
  }),
})
